import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import React from 'react';
import useSizeButton from './hooks/useSizeButton';

const SizeButton = ({ value, available, index, selectedSize, onSizeChange, theme, enhancedSizeSelectorClassName }) => {
  const { handleClick, buttonClassName, themedStyles, buttonId, isDisabled } = useSizeButton({
    value,
    available,
    index,
    selectedSize,
    onSizeChange,
    theme,
    enhancedSizeSelectorClassName,
  });

  return (
    <button
      id={buttonId}
      type="button"
      key={value}
      className={buttonClassName}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {value}
      <style jsx>{themedStyles}</style>
    </button>
  );
};

SizeButton.defaultProps = {
  theme: null,
  enhancedSizeSelectorClassName: '',
};

SizeButton.propTypes = {
  value: PropTypes.string.isRequired,
  available: PropTypes.bool.isRequired,
  index: PropTypes.string.isRequired,
  selectedSize: PropTypes.string.isRequired,
  onSizeChange: PropTypes.func.isRequired,
  theme: PropTypes.object,
  enhancedSizeSelectorClassName: PropTypes.string,
};

export default withTheme(SizeButton);
